/**
 * Skeleton loader for search results
 */
import { memo } from 'react'
import { Stack, Paper, Group, Skeleton } from 'components'

export const SearchResultSkeleton = memo(() => (
  <Stack spacing="sm">
    {[1, 2, 3, 4].map((i) => (
      <Paper key={i} p="md" radius="md" withBorder>
        <Group position="apart" align="flex-start" noWrap>
          <Group spacing="md" sx={{ flex: 1 }}>
            <Skeleton height={20} width={20} radius="sm" />
            <Stack spacing={8} sx={{ flex: 1 }}>
              <Group spacing="xs">
                <Skeleton height={20} width={80} radius="xl" />
                <Skeleton height={14} width={100} />
              </Group>
              <Skeleton height={16} width="90%" />
            </Stack>
          </Group>
        </Group>
      </Paper>
    ))}
  </Stack>
))

SearchResultSkeleton.displayName = 'SearchResultSkeleton'
